import { forwardRef, Suspense } from 'react';

import { useLazyComponent } from '@trello/use-lazy-component';

import type { DiscoveryAdPopperContainerProps } from './DiscoveryAdPopperContainer';

export const LazyDiscoveryAdPopperContainer = forwardRef<
  HTMLElement,
  DiscoveryAdPopperContainerProps
>((props, ref) => {
  // Lazy loads required providers
  const DiscoveryAdPopperContainer = useLazyComponent(
    () =>
      import(
        /* webpackChunkName: "discovery-ad-popper-container" */ './DiscoveryAdPopperContainer'
      ),
    { namedImport: 'DiscoveryAdPopperContainer' },
  );

  return (
    <Suspense fallback={null}>
      <DiscoveryAdPopperContainer {...props} />
    </Suspense>
  );
});
